// extracted by mini-css-extract-plugin
export var searchHeader = "_7k-0";
export var searchHeaderDark = "_7k-1";